<template>
  <figure class="quiz_figure">
    <img :src="image_source" alt="イメージ">
  </figure>
</template>

<script>
export default {
  name: 'QuizFigure',
  props: {
    image_source: {
      required: true
    }
  }
}
</script>

<style scoped>
  .quiz_figure {
    margin: 0;
    width: 388px;
    height: 286px;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
  }

  @media screen and (max-width: 767px) {
    .quiz_figure {
      width: 100%;
      height: 100%;
    }
  }

  .quiz_figure > img {
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 100%;
  }

  @media screen and (max-width: 767px) {
    .quiz_figure > img {
      width: 100%;
      height: 100%;
    }
  }

</style>
